import classnames from "classnames";
import PropTypes from "prop-types";

import "./icon.scss";

const Icon = ({ name, theme, size, className, ...restProps }) => {
  return (
    <i
      {...restProps}
      className={classnames("icon", className, {
        [`icon-${name}`]: name,
        [`icon--${theme}`]: theme,
        [`icon--${size}`]: size,
      })}
    />
  );
};

export const iconSizes = [
  "extra-extra-small",
  "extra-small",
  "small",
  "medium",
  "large",
  "extra-large",
  "extra-extra-large",
];
export const iconThemes = [
  "system",
  "brand",
  "success",
  "error",
  "disabled",
  "theme",
];

Icon.propTypes = {
  name: PropTypes.string,
  theme: PropTypes.oneOf(iconThemes),
  size: PropTypes.oneOf(iconSizes),
  className: PropTypes.string,
};

Icon.defaultProps = {
  name: "",
  theme: "system",
  size: "medium",
  className: undefined,
};

export default Icon;
